import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Form from "@rjsf/mui";
import validator from '@rjsf/validator-ajv8';
import { FC } from "react";
import * as apiClient from "../api";
import { Question } from "../types";
import { questionFormSchema, questionUiSchema } from "../types/rjsfSchema/question";


interface QuestionJsonDialogProps {
  question?: Question;
  open: boolean;
  handleClose: () => void;
  variant: "add" | "edit";
  handleUpdate: (question: Question) => void;
}

const QuestionJsonDialog: FC<QuestionJsonDialogProps> = ({ question, variant, open, handleClose, handleUpdate }) => {
  const onSubmit = async (data: Question) => {

    let new_question: Question;

    if (variant === "add") {

      if (data.answerType === "yes/no") {
        data.answerType = "select"
        data.answers = [
          { value: 0, patientDisplay: "Yes", clinicianDisplay: "Yes" },
          { value: 1, patientDisplay: "No", clinicianDisplay: "No" }
        ]
      }

      new_question = (await apiClient.addQuestion(data)).data.question
    } else {
      new_question = (await apiClient.editQuestion(data)).data.question
    }

    if (new_question)
      handleUpdate(new_question);


    handleClose()
  }

  const dialogTitle = variant === "add" ? "Add Question" : `Edit ${question ? question.questionId : "Question"}`;

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Form schema={questionFormSchema(variant, question)} formData={question} validator={validator} uiSchema={questionUiSchema(variant)} onSubmit={(data) => { onSubmit(data.formData as Question) }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  )

}

export default QuestionJsonDialog;